import React, { PureComponent } from 'react';
import { SketchPicker } from 'react-color';
import { Popover } from 'reactstrap';
import PropTypes from 'prop-types';

class SketchColorPickerField extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    hex: PropTypes.string.isRequired,
    // eslint-disable-next-line
    value: PropTypes.any.isRequired,
  };

  constructor(props) {
    super(props);

    const hexToRgb = (hex) => {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? { r: parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16), a: 1 }
        : { r: 0, g: 0, b: 0, a: 1 };
    };

    const { hex, value } = props;
    const color = value.length ? `#${value}` : `#${hex}`;

    this.state = {
      displayColorPicker: false,
      color,
      rgb: hexToRgb(color),
      active: false,
    };
  }

  handleClick = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ displayColorPicker: !prevState.displayColorPicker, active: !prevState.active }));
  };

  handleChange = (color) => {
    const { onChange } = this.props;
    this.setState({ color: color.hex, rgb: color.rgb });
    onChange(color);
  };

  render() {
    const { name } = this.props;
    const { active, color, displayColorPicker, rgb } = this.state;

    return (
      <div className="color-picker">
        <button
          type="button"
          className={`color-picker__button${active ? ' active' : ''}`}
          onClick={this.handleClick}
          id={name}
        >
          <p className="color-picker__color">{color}</p>
          <div className="color-picker__color-view" style={{ backgroundColor: color }} />
        </button>
        <Popover isOpen={displayColorPicker} target={name} placement="bottom" className="color-picker__popover">
          <SketchPicker color={rgb} onChange={this.handleChange} />
        </Popover>
      </div>
    );
  }
}

const renderSketchColorPickerField = (props) => {
  const { input, meta, hex } = props;
  return (
    <div className="form__form-group-input-wrap">
      <SketchColorPickerField {...input} hex={hex} />
      {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
    </div>
  );
};

renderSketchColorPickerField.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    name: PropTypes.string,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  hex: PropTypes.string,
};

renderSketchColorPickerField.defaultProps = {
  meta: null,
  hex: 'ff4861',
};

export default renderSketchColorPickerField;
